'use strict';

require('core/contactUs');
